import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useRevalidateModules } from '@systemeio/util';
import useUser from 'shared/hooks/use-user';
import { CountInterface, DataWithPaginationInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import { baseFetcher } from 'shared/utils/http-client';
import { SUB_ACCOUNTS_API } from '../api/sub-accounts-api';
import { SubAccountInterface, SubAccountNewLeadsInterface, SubAccountResourcesInterface, SubAccountSalesInterface } from '../types/sub-account-interface';
interface UseSubAccountsInterface extends SwrPaginationInterface {}
export const useSubAccounts = t0 => {
  const $ = _c(37);
  const {
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: resourcesFetcher
  } = useFetch(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.get
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    fetcher: salesFetcher
  } = useFetch(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      method: RequestMethodsEnum.get
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    fetcher: newLeadsFetcher
  } = useFetch(t4);
  let t5;
  if ($[4] !== limit || $[5] !== pagination || $[6] !== user) {
    t5 = () => user && [`${SUB_ACCOUNTS_API}/list?${getPaginationQueryString({
      limit,
      pagination
    })}`, RequestModuleEnum.SubAccounts, RequestModuleEnum.SubAccountsListing];
    $[4] = limit;
    $[5] = pagination;
    $[6] = user;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data: subAccounts,
    mutate
  } = useControlledSwr(t5, fetcher, undefined, undefined);
  let t6;
  if ($[8] !== limit || $[9] !== pagination || $[10] !== user) {
    t6 = () => {
      if (user) {
        return [`${SUB_ACCOUNTS_API}/count?${getPaginationQueryString({
          limit,
          pagination
        })}`, RequestModuleEnum.SubAccounts, RequestModuleEnum.SubAccountsCounters];
      }
      return null;
    };
    $[8] = limit;
    $[9] = pagination;
    $[10] = user;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    data: counter
  } = useControlledSwr(t6, baseFetcher, undefined, undefined);
  let t7;
  if ($[12] !== limit || $[13] !== pagination || $[14] !== user) {
    t7 = () => user && [`${SUB_ACCOUNTS_API}/resources?${getPaginationQueryString({
      limit,
      pagination
    })}`, RequestModuleEnum.SubAccounts, RequestModuleEnum.SubAccountsResources];
    $[12] = limit;
    $[13] = pagination;
    $[14] = user;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const {
    data: resources,
    isLoading: isLoadingResources
  } = useControlledSwr(t7, resourcesFetcher, undefined, undefined);
  let t8;
  if ($[16] !== limit || $[17] !== pagination || $[18] !== user) {
    t8 = () => user && [`${SUB_ACCOUNTS_API}/stats/sales?${getPaginationQueryString({
      limit,
      pagination
    })}`, RequestModuleEnum.SubAccounts, RequestModuleEnum.SubAccountsSales];
    $[16] = limit;
    $[17] = pagination;
    $[18] = user;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const {
    data: sales,
    isLoading: isLoadingSales
  } = useControlledSwr(t8, salesFetcher, undefined, undefined);
  let t9;
  if ($[20] !== limit || $[21] !== pagination || $[22] !== user) {
    t9 = () => user && [`${SUB_ACCOUNTS_API}/stats/new-leads?${getPaginationQueryString({
      limit,
      pagination
    })}`, RequestModuleEnum.SubAccounts, RequestModuleEnum.SubAccountsNewLeads];
    $[20] = limit;
    $[21] = pagination;
    $[22] = user;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const {
    data: newLeads,
    isLoading: isLoadingNewLeads
  } = useControlledSwr(t9, newLeadsFetcher, undefined, undefined);
  let t10;
  if ($[24] !== revalidateModules) {
    t10 = hardRevalidate => {
      revalidateModules([RequestModuleEnum.SubAccounts], hardRevalidate);
    };
    $[24] = revalidateModules;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const revalidateSubAccountsModule = t10;
  let t11;
  if ($[26] !== counter || $[27] !== isLoadingNewLeads || $[28] !== isLoadingResources || $[29] !== isLoadingSales || $[30] !== mutate || $[31] !== newLeads || $[32] !== resources || $[33] !== revalidateSubAccountsModule || $[34] !== sales || $[35] !== subAccounts) {
    t11 = {
      subAccounts,
      counter,
      mutate,
      resources,
      isLoadingResources,
      sales,
      isLoadingSales,
      newLeads,
      isLoadingNewLeads,
      revalidateSubAccountsModule
    };
    $[26] = counter;
    $[27] = isLoadingNewLeads;
    $[28] = isLoadingResources;
    $[29] = isLoadingSales;
    $[30] = mutate;
    $[31] = newLeads;
    $[32] = resources;
    $[33] = revalidateSubAccountsModule;
    $[34] = sales;
    $[35] = subAccounts;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
};